import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import { ApplicationDialog } from "./ApplicationDialog";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const statusMap = {
  pending: { label: "待审核", color: "bg-yellow-500" },
  approved: { label: "已通过", color: "bg-green-500" },
  rejected: { label: "已拒绝", color: "bg-red-500" }
};

const typeMap = {
  personal: "个人",
  business: "企业"
};

export const ApplicationList = ({ applications, onUpdate }: { 
  applications: any[],
  onUpdate: () => void 
}) => {
  const [selectedApp, setSelectedApp] = useState<any>(null);

  const deleteApplication = async (id: string) => {
    const { error } = await supabase
      .from('cert_applications')
      .delete()
      .eq('id', id);

    if (error) {
      toast.error("删除失败");
    } else {
      toast.success("删除成功");
      onUpdate();
    }
  };

  const filteredApplications = (status: string) => {
    return applications.filter(app => app.status === status);
  };

  return (
    <Tabs defaultValue="pending" className="w-full">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="pending">待审核申请</TabsTrigger>
        <TabsTrigger value="approved">已通过申请</TabsTrigger>
        <TabsTrigger value="rejected">已拒绝申请</TabsTrigger>
      </TabsList>

      {["pending", "approved", "rejected"].map((status) => (
        <TabsContent key={status} value={status}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-white">申请编号</TableHead>
                <TableHead className="text-white">申请人</TableHead>
                <TableHead className="text-white">域名</TableHead>
                <TableHead className="text-white">类型</TableHead>
                <TableHead className="text-white">状态</TableHead>
                <TableHead className="text-white">申请时间</TableHead>
                <TableHead className="text-white">操作</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredApplications(status).map((app) => (
                <TableRow key={app.id}>
                  <TableCell className="text-white font-mono">{app.cert_number}</TableCell>
                  <TableCell className="text-white">{app.applicant_name}</TableCell>
                  <TableCell className="text-white">{app.domain}</TableCell>
                  <TableCell className="text-white">{typeMap[app.applicant_type as keyof typeof typeMap]}</TableCell>
                  <TableCell>
                    <Badge className={`${statusMap[app.status as keyof typeof statusMap].color} text-white`}>
                      {statusMap[app.status as keyof typeof statusMap].label}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-white">
                    {format(new Date(app.created_at), 'yyyy-MM-dd HH:mm')}
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setSelectedApp(app)}
                        className="hover:bg-white/10"
                      >
                        处理
                      </Button>
                      <Button
                        variant="destructive"
                        size="sm"
                        onClick={() => deleteApplication(app.id)}
                      >
                        删除
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TabsContent>
      ))}

      <ApplicationDialog
        application={selectedApp}
        onClose={() => setSelectedApp(null)}
        onUpdate={onUpdate}
      />
    </Tabs>
  );
};